import { Col, Row } from 'antd';
import React from 'react';
import SkeletonCustom from './SkeletonCustom';
import TypoGraphySkeleton from './TypoGraphySkeleton';

const PersonalityInsightsSkeleton = function PersonalityInsightsSkeleton() {
  return (
    <>
      <Row gutter={16} className="pills-one-liner">
        <Col span={24}>
          <SkeletonCustom height="550px" width="100%" />
        </Col>
        {/* <Col span={8}>
          <SkeletonCustom height="250px" width="100%" />
        </Col>
        <Col span={8}>
          <SkeletonCustom height="250px" width="100%" />
        </Col> */}
      </Row>
      <Row gutter={16} className="pills-one-liner mt-c-40">
        <Col span={12}>
          <TypoGraphySkeleton />
        </Col>
        <Col span={12}>
          <TypoGraphySkeleton />
        </Col>
      </Row>
      <Row gutter={16} className="pills-one-liner mt-c-40">
        <Col span={8}>
          <SkeletonCustom height="250px" width="100%" />
        </Col>
        <Col span={8}>
          <SkeletonCustom height="250px" width="100%" />
        </Col>
        <Col span={8}>
          <SkeletonCustom height="250px" width="100%" />
        </Col>
      </Row>
      <Row gutter={16} className="pills-one-liner mt-c-40">
        <Col span={12}>
          <TypoGraphySkeleton />
        </Col>
        <Col span={12}>
          <TypoGraphySkeleton />
        </Col>
      </Row>
    </>
  );
};

export default PersonalityInsightsSkeleton;
